import { assumptionsSchema, simulationSchema, type Assumptions, type Simulation, type SimulationInput } from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function fetchAssumptions(): Promise<Assumptions> {
  return apiFetch('/api/assumptions', { schema: assumptionsSchema });
}

export function fetchSimulations(): Promise<Simulation[]> {
  return apiFetch('/api/simulations', { schema: z.array(simulationSchema) });
}

export function fetchSimulation(id: number): Promise<Simulation> {
  return apiFetch(`/api/simulations/${id}`, { schema: simulationSchema });
}

export function createSimulation(input: SimulationInput): Promise<Simulation> {
  return apiFetch('/api/simulations', { method: 'POST', body: input, schema: simulationSchema });
}
